// src/pages/ProviderProfile.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../context/AuthContext';
import './ProfilePages.css';

const ProviderProfile = () => {
  const { user, logout } = useAuth();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    getDoc(doc(db, 'users', user.uid)).then(snap => {
      if (snap.exists()) setProfile(snap.data());
      setLoading(false);
    });
  }, [user]);

  if (!user) return <div className="page-wrapper"><p>Please <Link to="/login">log in</Link>.</p></div>;

  const credits = profile?.credits ?? 0;
  const rating  = profile?.rating  ?? 0;
  const rank    = profile?.rank    ?? '—';
  const jobs    = profile?.jobs    ?? 0;
  return (
    <div className="page-wrapper page-wrapper-sm">
      <h1 className="section-title">CARRIER <span>PROFILE</span></h1>
      <div className="card profile-card">
        <div className="profile-avatar provider-av">{user.name?.charAt(0) || 'P'}</div>
        <div className="profile-name">{user.name}</div>
        <div className="profile-email">{user.email}</div>
        <div className="profile-type badge badge-teal">Carrier · Rank #{rank}</div>
        <hr className="divider" />
        {loading ? (
          <p className="text-muted" style={{textAlign:'center',padding:'16px 0'}}>Loading stats...</p>
        ) : (
          <>
            <div className="profile-stats">
              <div className="pstat-sm"><div className="pstat-v teal">{credits}</div><div className="pstat-l">Eco Credits</div></div>
              <div className="pstat-sm"><div className="pstat-v amber">{rating}★</div><div className="pstat-l">Rating</div></div>
              <div className="pstat-sm"><div className="pstat-v">{jobs}</div><div className="pstat-l">Jobs Done</div></div>
            </div>
            <hr className="divider" />
          </>
        )}
        <Link to="/provider-dashboard" className="btn btn-primary btn-full">GO TO DASHBOARD</Link>
        <button className="btn btn-secondary btn-full" style={{marginTop:'10px'}} onClick={logout}>LOGOUT</button>
      </div>
    </div>
  );
};

export default ProviderProfile;
